import { render, staticRenderFns } from "./AuroraWrapper.vue?vue&type=template&id=7863767b"
import script from "./AuroraWrapper.vue?vue&type=script&lang=js"
export * from "./AuroraWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports